export const ICON_SIZE_IN_PIXEL = 14;
export const STAR_ICON_SIZE_IN_PIXEL = 13;
export const TEXTBOX_ICON_SIZE_IN_PIXEL = 20;
export const MOBILE_READ_MORE = 'Read More';
export const MOBILE_SHOW_LESS = 'Show Less';
export const POINT_DESCRIPTION = 'MCF points determine the rank of the user. The higher the points, the higher the rank.'; // @suppress longLineCheck
export const RANKING_DESCRIPTION = 'The rank of the users represents his reputation, the higher the rank, the better the reputation is. Ranks are in ascending order.'; // @suppress longLineCheck
export const GRADE_TO_POINT_LINK = 'https://www.mycarforum.com/forums/topic/2691364-guide-to-point-system/';
export const REVIEWER_LINK = 'https://www.mycarforum.com/index.php?app=core&module=members&controller=profile';

export const CONSUMER_REVIEW_ICON_18 = 18;
export const CONSUMER_REVIEW_ICON_16 = 16;
export const CONSUMER_REVIEW_ICON_20 = 20;

export const TEXTBOX_ICON_SRC = '/public/new-cars/icon/textbox.svg';
export const SMILE_ICON_SRC = '/public/new-cars/icon/smile.svg';
export const SAD_ICON_SRC = '/public/new-cars/icon/sad.svg';
export const TEXT_REVIEW = 'Review';
export const TEXT_WHAT_I_LIKE = 'What I Like';
export const TEXT_WHAT_I_DISLIKE = 'What I Dislike';
export const CONSUMER_DEFAULT_IMAGE = 'https://www.mycarforum.com/public/style_images/master/profile/default_large.png';
